import React, {useContext} from 'react'
import "./style.scss"
import {AuthContext} from "../../../context/auth";

const Index = () => {
    const {setLogOutModal, logout} = useContext(AuthContext)
  return (
    <div className="small-modal-wrapper">
        <div className="logout-modal-content">
        <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '15px', top: '12px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
          setLogOutModal(false)
        }}></i>
        <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#DC1E00', color: 'var(--white)' }}>
            <i class="fal fa-sign-out" style={{fontWeight:'300' }}></i>
            </span>
            <h2>Are you sure? </h2>
            <p style={{marginBottom:'20px'}}>You will be logged out of <span>Identifyn Admin.</span></p>
            <button className='btn' style={{background: 'var(--primary-color)', color: 'var(--white)'}} onClick={() => {
                logout()
                setLogOutModal(false)
            }}>Log Out</button>
            <button className='btn transparent' onClick={() => {
                setLogOutModal(false)
            }}>Cancel</button>
        </div>
    </div>
  )
}

export default Index